import Mood from 'assets/image/SurveyStyle/Mood.png';
import Photo from 'assets/image/SurveyStyle/Photo.png';
import Food from 'assets/image/SurveyStyle/Food.png';
import Shopping from 'assets/image/SurveyStyle/Shopping.png';
import Book from 'assets/image/SurveyStyle/Book.png';
import Paint from 'assets/image/SurveyStyle/Paint.png';
import Sight from 'assets/image/SurveyStyle/Sight.png';
import Movie from 'assets/image/SurveyStyle/Movie.png';
import Music from 'assets/image/SurveyStyle/Music.png';
import Nature from 'assets/image/SurveyStyle/Nature.png';
import Healing from 'assets/image/SurveyStyle/Healing.png';
import Health from 'assets/image/SurveyStyle/Health.png';

const SurveyStyleData = [
  {
    id: 1,
    img: Mood,
    text: '분위기',
    english: 'VIBE'
  },
  {
    id: 2,
    img: Photo,
    text: '사진촬영',
    english: 'PICTURE'
  },
  {
    id: 3,
    img: Food,
    text: '맛집탐방',
    english: 'RESTAURANT'
  },
  {
    id: 4,
    img: Shopping,
    text: '쇼핑',
    english: 'SHOPPING'
  },
  {
    id: 5,
    img: Book,
    text: '독서/문학',
    english: 'LITERATURE'
  },
  {
    id: 6,
    img: Paint,
    text: '미술/예술',
    english: 'ART'
  },
  {
    id: 7,
    img: Sight,
    text: '풍경',
    english: 'SCENERY'
  },
  {
    id: 8,
    img: Movie,
    text: '문화/역사',
    english: 'CULTURE'
  },
  {
    id: 9,
    img: Music,
    text: '음악/공연',
    english: 'ENTERTAINMENT'
  },
  {
    id: 10,
    img: Nature,
    text: '자연/야외',
    english: 'NATURE'
  },
  {
    id: 11,
    img: Healing,
    text: '휴식/힐링',
    english: 'HEALING'
  },
  {
    id: 12,
    img: Health,
    text: '건강/웰니스',
    english: 'HEALTH'
  }
];

export default SurveyStyleData;
